export class PhonePrefix {
    countryCode?: string;
}